import React, { useState, FunctionComponent } from "react";
import Button from "@material-ui/core/Button";
import {Grid} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

type ItemCategoryDialogProps = {
  openCategoryDialog: boolean;
  closeCategoryDialog: () => void;
  updateCategory: (value:string, resetForm:()=>void) => void;
  resetForm: () => void;
};
export const ItemCategoryDialog: FunctionComponent<
  ItemCategoryDialogProps
> = ({
    openCategoryDialog,
    closeCategoryDialog,
    updateCategory,
    resetForm
}) => {
  const [value, setValue] = useState<string>("pieces");
  
  return (
    <Dialog
        open={openCategoryDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
        <DialogTitle id="simple-dialog-title">
            Please select a category for returning your item :
        </DialogTitle>

        <Grid container style={{paddingTop:"2em"}}>
          <Grid item >
            <RadioGroup
              aria-label="position"
              row
              name="value"
              onChange={(event: any) => {
                setValue(event.target.value);
              }}
              value={value}
            >
              <FormControlLabel
                value="pieces"
                control={<Radio color="primary" />}
                label="Pieces"
                labelPlacement="end"
              />
              <FormControlLabel
                value="carton"
                control={<Radio color="primary" />}
                label="Carton"
                labelPlacement="end"
              />
            </RadioGroup>
          </Grid>
        </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
              updateCategory(value, resetForm);
              }} id="buton">
            Submit
          </Button>
          <Button
            onClick={() => {
                closeCategoryDialog();
            }}
            autoFocus
            id="buton"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
  );
};
